/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeOptions } from '@mui/material/styles';

export const CssBaseline: ThemeOptions = {
	components: {
		MuiCssBaseline: {
			styleOverrides: (theme) => `
			${theme.fonts
				.map(
					({ family, style, display, weight, src }) => `
						@font-face {
							font-family: ${family};
							font-style: ${style};
							font-display: ${display};
							font-weight: ${weight};
							src: ${src};
						}
						`
				)
				.join(``)}
            html, #__next { max-width: 100vw; min-height: 100vh; display: flex; flex: 1}
			body { max-width: 100vw; min-height: 100vh; display: flex; flex: 1; overflow-x: hidden; overflow-y: auto !important;}
			#__next {flex-direction: column; }
			#__next > main {flex: 1;}
			img {
				max-width: 100%;
			}
			img[src*="https://tracker.metricool.com/"] {
				display: none;
			}

			nextjs-portal {
				display: none;
			}

			.heading-title {
				margin-bottom: 15px;
				margin-top: 15px;
			}
			
			.heading-title h1 {
				font-size: 18px;
				font-weight: 800;
				text-transform: uppercase;
			}
			
			.heading-title h2 {
				font-size: 18px;
				color: #2b368d;
				border-left: 1px solid #343434;
				padding-left: 13px;
				margin-left: 13px;
				font-size: 1.14em;
				font-weight: 700;
			}

			.heading-title span {
				color: #2b368d;
				border-left: 1px solid #343434;
				padding-left: 13px;
				margin-left: 13px;
				font-size: 1.14em;
				font-weight: 700;
			}

			.heading-title p {
				font-size: 16px;
				font-weight: 400;
				margin-bottom: 15px;
			}

			@media (max-width: 768px) {
				.heading-title {
					display: flex;
					flex-direction: column;
					gap: 3px;
					margin-bottom: 11px;
					margin-top: 11px;
				}
					
				.heading-title h1 {
					font-size: 19px;
				}

				.heading-title h2 {
					font-size: 16px;
					border-left: none;
					margin-left: 0;
					padding-left: 0;
				}

				.heading-title span {
					font-size: 14px;
					border-left: none;
					margin-left: 0;
					padding-left: 0;
				}

				.heading-title p {
					font-size: 14px;
					margin-bottom: 11px;
				}

				.heading-title br {
					display: none;
				}
			}
		
			.tabs-ofertas {
				display: none !important;
			}

			.seoContainer {
				display: block;
				width: 100%;
				font-family: Arial, sans-serif;
				color: #333;
				margin: 0 auto !important;
				max-width: 1200px;
				padding-left: 16px;
				padding-right: 16px;
				box-sizing: border-box;
				display: flex;
				flex-direction: column;
				margin-bottom: 40px !important;
				float: none !important;
				
				@media (min-width: 600px) {
					padding-left: 16px;
					padding-right: 16px;
					margin-bottom: 80px !important;
				}
				@media (min-width: 1200px) {
					max-width: 1280px;
					padding-left: 0px;
					padding-right: 0px;
					margin-bottom: 80px !important;
				}
			}

			.seoContainer h2 {
				font-size: 16px;
				color: #2c2c2c;
				margin-bottom: 10px;
				font-weight: 800;
				text-transform: uppercase;
			}

			.seoContainer h3 {
				font-size: 14px;
				padding: 5px 0px;
				font-weight: 700;
				text-transform: uppercase;
				line-height: 26px;
			}

			.seoContainer p {
				margin: 0;
				font-size: 14px;
				font-weight: 400;
				font-family: Open Sans, "Helvetica Neue", Arial, sans-serif;
				line-height: 1.5;
			}

			.seoContainer p:last-child {
				margin-bottom: 0;
			}

			.seoContainer a {
				color: #007BFF;
				text-decoration: none;
			}

			.seoContainer a:hover {
				text-decoration: underline;
			}
			.banner .title {
				position: absolute;
				left: -80px;
				
			}

			.banner {
				position: relative;
				text-align: center;
				color: white;
			}

			.banner img {
				width: 100%;
				height: auto;
			}

			.banner .row {
				position: absolute;
				top: 50%;
				transform: translate(-50%, -50%);
			}

			.banner .bloque-text {
				
				padding: 10px;
				border-radius: 5px;
			}

			.banner .mobile-hidden {
				display: block;
			}

			.banner .desktop-hidden {
				display: none;
			}

			@media screen and (max-width: 640px) {
				.banner .mobile-hidden {
					display: none;
				}

				.banner .desktop-hidden {
					display: block;
				}
			}

			:root{
				--spacing-1: 4px;
				--spacing-2: 8px;
				--spacing-3: 12px;
				--spacing-4: 16px;
				--spacing-5: 20px;
				--spacing-6: 24px;
				--spacing-7: 32px;
				--spacing-8: 40px;
				--spacing-9: 48px;
				--spacing-10: 56px;
				--spacing-11: 64px;
				--spacing-12: 72px;
				--spacing-13: 80px;
				--spacing-14: 88px;
				--spacing-15: 96px;

				--font-size-biggest: 65px;
				--font-size-display: 40px;
				--font-size-xxl: 30px;
				--font-size-xl: 24px;
				--font-size-lg: 20px;
				--font-size-md: 18px;
				--font-size-sm: 16px;
				--font-size-body: 15px;
				--font-size-default: 14px;
				--font-size-small: 13px;
				--font-size-caption: 12px;
				--font-size-tiny: 11px;
				--font-size-micro: 10px;
			}

			.grecaptcha-badge {
				z-index: 10000 !important;
				@media (max-width: 768px) {
					bottom: 90px !important;
				}
			}
			.iiz {
				height: 100% !important;
				width: 100% !important;
				object-fit: contain !important;
				display: flex !important;
				justify-content: center !important;
				align-items: center !important;
				div, img {
					object-fit: contain !important;
					height: 100% !important;
				}
			}

			.iiz {
				max-width: 100%;
				margin: 0;
				position: relative;
				overflow: hidden;
				display: inline-block;
				cursor: -webkit-zoom-in;
				cursor: zoom-in;
				}

				.iiz--drag .iiz__zoom-img--visible {
				cursor: -webkit-grab;
				cursor: grab;
				}

				.iiz__img {
				max-width: 100%;
				height: auto;
				display: block;
				pointer-events: none;
				visibility: visible;
				opacity: 1;
				}

				.iiz__img--hidden {
				visibility: hidden;
				opacity: 0;
				}

				.iiz__img--abs {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				display: block;
				}

				.iiz__zoom-img {
				width: auto !important;
				max-width: none !important;
				position: absolute;
				visibility: hidden;
				opacity: 0;
				pointer-events: none;
				-webkit-touch-callout: none;
				display: block;
				}

				.iiz__zoom-img--visible {
				visibility: visible;
				opacity: 1;
				pointer-events: auto;
				cursor: -webkit-zoom-out;
				cursor: zoom-out;
				-ms-touch-action: none;
				touch-action: none;
				}

				.iiz__zoom-portal {
				position: fixed;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				z-index: 10000;
				}

				.iiz__btn {
				background: rgba(255, 255, 255, 0.8);
				width: 40px;
				height: 40px;
				border: none;
				outline: none;
				padding: 0;
				position: absolute;
				text-decoration: none;
				display: -webkit-box;
				display: -ms-flexbox;
				display: flex;
				-webkit-box-align: center;
				-ms-flex-align: center;
				align-items: center;
				-webkit-box-pack: center;
				-ms-flex-pack: center;
				justify-content: center;
				-moz-appearance: none;
				-webkit-appearance: none;
				appearance: none;
				}

				.iiz__btn:before {
				content: " ";
				background-position: center;
				background-repeat: no-repeat;
				display: block;
				}

				.iiz__hint {
				bottom: 10px;
				right: 10px;
				pointer-events: none;
				}

				.iiz__hint:before {
				content: " ";
				background-image: url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 19.9 19.9%27%3E%3Cpath d=%27M13.9 7.4C13.9 3.8 11 .9 7.4.9S.9 3.8.9 7.4s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5zm5.3 12.5l-6.7-7.2c-1.4 1.3-3.2 2.1-5.1 2.1-4.1 0-7.4-3.3-7.4-7.4S3.3 0 7.4 0s7.4 3.3 7.4 7.4c0 1.7-.6 3.4-1.7 4.7l6.8 7.2-.7.6z%27 fill=%27%23000222%27/%3E%3C/svg%3E");
				width: 20px;
				height: 20px;
				}

				.iiz__close {
				top: 10px;
				right: 10px;
				visibility: hidden;
				opacity: 0;
				}

				.iiz__close--visible {
				visibility: visible;
				opacity: 1;
				cursor: pointer;
				}

				.iiz__close::before {
				content: " ";
				width: 29px;
				height: 29px;
				background-image:
					-webkit-gradient(linear, left top, left bottom, from(#222), to(#222)),
					-webkit-gradient(linear, left top, left bottom, from(#222), to(#222));
				background-image: -o-linear-gradient(#222, #222), -o-linear-gradient(#222, #222);
				background-image: linear-gradient(#222, #222), linear-gradient(#222, #222);
				background-size: 100% 1px, 1px 100%;
				margin: 0 auto;
				-webkit-transform: rotate(45deg);
				-ms-transform: rotate(45deg);
				transform: rotate(45deg);
				}
            `,
		},
	},
};
